
<alert id="splashscreen">
  <div class="customsplash" style="display:block;">
    <div class="spinnersplash">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
</alert>

<alert id="commonalert">
  <div class="modalcontainer">
    <div class="modal">
      <div class="close"><span (click)="closeAlert()">&#43;</span></div>
      <div class="modalcontent">
        <h2 id="pTitle"></h2>
        <p id="pTarget" style="word-wrap:break-word; white-space: pre-wrap;"></p>
      </div>
    </div>
  </div>
</alert>

<q-toast></q-toast>

<header>

  <nav class="navbar navbar-expand-lg navbar-light" *ngIf="isLoggedIn">
    <a class="navbar-brand" (click)="openPage('HME')">
      <div class="main-logo d-inline-block align-top ispointer" alt=""></div>
    </a>

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">  <!--*ngIf="showMenu">-->
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent"> <!--*ngIf="showMenu">-->
      <ul class="navbar-nav ml-auto">
        <li class="nav-item active">
          <a class="nav-link" (click)="openPage('CTL')">{{customLabel('HOME', 'menuCAT')}}</a>
        </li>
        <li class="nav-item active" *ngIf="model.hasStages">
          <a class="nav-link" (click)="openPage('SES')">{{customLabel('HOME', 'menuSES')}}</a>
        </li>
        <li class="nav-item active" *ngIf="model.hasCursus">
          <a class="nav-link" (click)="openPage('CYC')">{{customLabel('HOME', 'menuCYC')}}</a>
        </li>
        <li class="nav-item dropdown" *ngIf="model.isAdmin">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{trad('menuADM')}}</a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" (click)="openPage('ADMCAT')">{{customLabel('HOME', 'menuCAT')}}</a>
            <a class="dropdown-item" (click)="openPage('ADMCYC')">{{customLabel('HOME', 'menuCYC')}}</a>
            <!--<div class="dropdown-divider"></div>
            <a class="dropdown-item" (click)="openPage('ADMCNF')">Configuration</a>-->
          </div>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{trad('menuLAN')}}</a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" (click)="changeLanguage('en-GB')">{{trad('menuEN')}}</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" (click)="changeLanguage('fr-FR')">{{trad('menuFR')}}</a>
          </div>
        </li>
      </ul>
    </div>
  </nav>

</header>

<router-outlet></router-outlet>


